export default __webpack_public_path__ + "static/media/arrow-ups-new.e3e1d5a3.svg";